import { Dispatch, FC, SetStateAction } from 'react';
import { Button, DropdownItem } from 'reactstrap';
import { handleMultipleModalsWithOneState } from '../../../../helpers/helpers';
import { Modal } from '../../../../Components/Custom/modal';
import { OPENED_MODAL } from '../types';
import { useAppDispatch } from '../../../../app/hooks';
import { cancelEventTicket } from '../slice';

export const Storno: FC<{
  setIsOpen: Dispatch<SetStateAction<number>>;
}> = ({ setIsOpen }) => {
  return (
    <DropdownItem
      tag='a'
      href='/'
      className='w-100'
      onClick={(e) => {
        e.preventDefault();
      }}>
      <div
        style={{ width: '100%' }}
        onClick={() => setIsOpen(OPENED_MODAL.CANCEL)}>
        Cancel
      </div>
    </DropdownItem>
  );
};

export const StornoModal: FC<{
  id: number;
  setIsOpen: Dispatch<SetStateAction<number>>;
  isOpen: number;
}> = ({ id, isOpen, setIsOpen }) => {
  const dispatch = useAppDispatch();

  return (
    <Modal
      isOpen={isOpen === OPENED_MODAL.CANCEL}
      setIsOpen={() => handleMultipleModalsWithOneState(isOpen, setIsOpen)}
      title='Storno'
      actions={
        <>
          <Button
            color='primary'
            outline
            onClick={() => setIsOpen(OPENED_MODAL.CLOSED)}
            className='m-1'>
            Cancel
          </Button>
          <Button
            color='primary'
            className='m-1'
            onClick={() => {
              setIsOpen(OPENED_MODAL.CLOSED);
              dispatch(cancelEventTicket(id));
            }}>
            Yes
          </Button>
        </>
      }>
      <div className='mb-3'>
        <div className='avatar-lg mx-auto'>
          <div className='avatar-title bg-light text-primary display-5 rounded-circle'>
            <i className='ri-error-warning-fill '></i>
          </div>
        </div>
      </div>
      <h2>Are you sure?</h2>
      <p>You won’t be able to revert this!</p>
    </Modal>
  );
};
